// src/components/profile/ProfileTabs.js
import React from 'react';
import '../../styles/profile-tabs.css';

const ProfileTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="profile-tabs">
      {/* <button
        className={`tab-button ${activeTab === 'posts' ? 'active' : ''}`}
        onClick={() => onTabChange('posts')}
      >
        Posts
      </button> */}
      
      <button
        className={`tab-button ${activeTab === 'followers' ? 'active' : ''}`}
        onClick={() => onTabChange('followers')}
      >
        Followers
      </button>
      
      <button
        className={`tab-button ${activeTab === 'following' ? 'active' : ''}`}
        onClick={() => onTabChange('following')}
      >
        Following
      </button>
    </div>
  );
};

export default ProfileTabs;